import { useEffect, useState } from "react";
import crossIcon from "../../Assets/closeIcon.svg";
import { skillsSuggestions } from "../../data/skills";

export const CompanySkillsInput = ({ selectedSkills = [], setSelectedSkills }) => {
    const [showList, setShowList] = useState(false);
    const [inputValue, setInputValue] = useState('');

    useEffect(() => {
        setShowList(true);
    }, [inputValue]);

    const listToShow = skillsSuggestions
        ?.filter(item => 
            item?.toLowerCase()?.startsWith(inputValue?.toLowerCase()) &&
            !selectedSkills.includes(item)
        )
        ?.slice(0, 1000);

    const needToShow = () => {
        if (listToShow.length === 0 || inputValue.length < 1) {
            return false;
        }
        return showList;
    };

    const handleAddSkill = (skill) => {
        if (selectedSkills.length < 3 && !selectedSkills.includes(skill)) {
            setSelectedSkills([...selectedSkills, skill]);
            setInputValue('');
            setShowList(false);
        }
    };

    const handleRemoveSkill = (skill) => {
        setSelectedSkills(selectedSkills.filter(item => item !== skill));
        setInputValue('');
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && inputValue.trim()) {
            const exists = skillsSuggestions.some(item => 
                item.toLowerCase() === inputValue.trim().toLowerCase()
            );
            
            if (!exists && selectedSkills.length < 3 && !selectedSkills.includes(inputValue.trim())) {
                handleAddSkill(inputValue.trim());
            }
        }
    };

    return (
        <div>
            <label className="block text-sm font-medium mb-2">Select the Skills which you want to evaluate yourself for (Add exactly 3) (Press ENTER after inputting each Skill)</label>
            <div className='bg-white rounded-xl px-4 py-2 w-full border border-input-box-border border-solid flex flex-wrap items-center gap-2 relative'>
                {selectedSkills?.map((item, index) => (
                    <div
                        key={index}
                        className='flex items-center gap-1 bg-gray-100 px-2 py-1 rounded-xl'
                    >
                        <span className='text-sm text-[#3A3A3A]'>{item}</span>
                        <img
                            onClick={() => handleRemoveSkill(item)}
                            src={crossIcon}
                            className='w-[0.6rem] cursor-pointer'
                            alt="remove skill"
                        />
                    </div>
                ))}
                {selectedSkills.length < 3 && (
                    <input
                        className='flex-grow outline-none text-sm placeholder:text-placeholder_color border-input-box-border px-2'
                        placeholder={selectedSkills?.length === 0 ? 'e.g. JavaScript, React, Node.js, Python' : ''}
                        type="text"
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        onKeyDown={handleKeyDown}
                    />
                )}
                {needToShow() && (
                    <ul className='absolute bottom-[110%] bg-white max-h-72 overflow-auto w-full p-2 border-[2px] border-gray-500 rounded-lg left-0 right-0 mt-1 z-[10]'>
                        {listToShow?.map((item, index) => (
                            <li
                                className='cursor-pointer hover:bg-gray-100 p-[.4rem]'
                                onClick={() => handleAddSkill(item)}
                                key={index}
                            >
                                {item}
                            </li>
                        ))}
                    </ul>
                )}
            </div>
            <p className='text-xs text-gray-500 mt-1'>{selectedSkills.length}/3 selected</p>
        </div>
    );
};
